var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ff9d1e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.019 0.324)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(0.019 -0.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.056,162.988l-5.623-5.623,2.047-2.047,3.576,3.576,7.093-7.093,2.047,2.047Z",
    transform: "translate(-84.481 -145.226)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOrange);
export default __webpack_public_path__ + "static/media/check_orange.07a20fca61eb0525d638c2ada7e80a02.svg";
export { ForwardRef as ReactComponent };